module.exports = __webpack_public_path__ + "img/robot.c5218622.webp";